import React from 'react'
import { EventSearchResult } from './EventSearchResult'

import {
  DataViewEntity,
  DataViewRAC,
  DataViewRatables,
  PageSearch,
  MediaSearchResult,
  ResultItems,
  SearchRatingKey,
  SectionTitle
} from '.'

export enum SearchResultTypes {
  ENTITY = 'entity',
  RACS = 'racs', // Rating Actions not used in susf
  RESEARCH = 'research',
  ISSUE = 'issue',
  RATING_KEY = 'ratingKey', // Rating Keys not used in susf
  VIDEO = 'video',
  AUDIO = 'audio',
  EVENT = 'event',
  WEBINAR = 'webinar',
  RELATED_PAGES = 'page',
  NONE = ''
}

export enum SearchViewTypes {
  DATA = 'data',
  GRID = 'grid'
}

export type SearchResultsSectionProps = {
  activeViewType: string
  sectionNumber?: string
  sectionTitle?: string
  sectionTotalHits?: number
  sectionType: SearchResultTypes
  items?: any[]
  showBackLink?: boolean
  showViewControls?: boolean
  showPrintButton?: boolean
  isPrintPreview?: boolean
  handleBackClick?: () => void
  handleViewTypeClick?: (viewtype: string, sectionType: string) => void
  togglePrintOverlay?: () => void
}

const renderResultType = (
  activeViewType: string,
  items: any,
  sectionType: SearchResultTypes,
  isPrintPreview: boolean
) => {
  let component = (
    <ResultItems
      items={items}
      key={sectionType}
      isPrintPreview={isPrintPreview}
    />
  )
  switch (sectionType) {
    case SearchResultTypes.ENTITY:
      if (activeViewType === SearchViewTypes.DATA)
        component = <DataViewEntity items={items} key={sectionType} />
      break
    case SearchResultTypes.RACS:
    case SearchResultTypes.RESEARCH:
      if (activeViewType === SearchViewTypes.DATA)
        component = <DataViewRAC items={items} key={sectionType} />
      break
    case SearchResultTypes.ISSUE:
      if (activeViewType === SearchViewTypes.DATA)
        component = <DataViewRatables items={items} key={sectionType} />
      break
    case SearchResultTypes.VIDEO:
    case SearchResultTypes.AUDIO:
      component = <MediaSearchResult items={items} />
      break
    case SearchResultTypes.WEBINAR:
    case SearchResultTypes.EVENT:
      component = <EventSearchResult items={items} />
      break
    case SearchResultTypes.RELATED_PAGES:
      component = <PageSearch items={items} />
      break
    case SearchResultTypes.RATING_KEY:
      component = <SearchRatingKey />
      break
    default:
      component = (
        <ResultItems
          items={items}
          key={sectionType}
          isPrintPreview={isPrintPreview}
        />
      )
  }
  return component
}

export const SearchResultsSection = ({
  activeViewType,
  sectionNumber,
  sectionTitle,
  sectionTotalHits,
  sectionType,
  items = [],
  showBackLink = false,
  showViewControls = false,
  showPrintButton = false,
  isPrintPreview = false,
  handleBackClick = () => {},
  handleViewTypeClick = () => {},
  togglePrintOverlay = () => {}
}: SearchResultsSectionProps) => (
  <div className="page-layout page-layout--2__left-main content">
    <SectionTitle
      activeViewType={activeViewType}
      sectionNumber={sectionNumber}
      sectionTitle={sectionTitle}
      sectionTotalHits={sectionTotalHits}
      sectionType={sectionType}
      handleBackClick={handleBackClick}
      handleViewTypeClick={handleViewTypeClick}
      showBackLink={showBackLink}
      showViewControls={showViewControls}
      showPrintButton={showPrintButton}
      togglePrintOverlay={togglePrintOverlay}
    />
    {renderResultType(activeViewType, items, sectionType, isPrintPreview)}
  </div>
)
export default SearchResultsSection
